export const mapConfig = {
  apiGoogle: process.env.REACT_APP_MAP_GOOGLE,
  apiMapBox: process.env.REACT_APP_MAP_MAPBOX
};

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
